<template>
  <footer>
    <div class="container">
        <div class="row">
            <div class="col-md-4">
                <div class="widget">
                    <h4 class="widgetheading">株式会社アサテクス</h4>
                    <!-- Accordion starts -->
                    <div class="panel-group" id="accordion-footer">
                    <!-- Panel. Use "panel-XXX" class for different colors. Replace "XXX" with color. -->
                      <div>
                         <div class="panel-heading">
                            <h4 class="panel-title">
                              <a data-toggle="collapse" data-parent="#accordion-footer" href="#collapse3-alt3">
                                <i class="fa fa-angle-right"></i>会社情報
                              </a>
                            </h4>
                         </div>
                         <div id="collapse3-alt3" class="panel-collapse collapse">
                            <div>
                              　　<router-link to="/company">会社概要</router-link><br>
                              　　<router-link to="/news">ニュース・お知らせ</router-link>
                            </div>
                         </div>
                      </div>
                      <div>	
                        <!-- Panel heading -->
                         <div class="panel-heading">
                            <h4 class="panel-title">
                              <a data-toggle="collapse" data-parent="#accordion-footer" href="#collapse1-alt3">
                                <i class="fa fa-angle-right"></i>業務内容
                              </a>
                            </h4>
                         </div>
                         <div id="collapse1-alt3" class="panel-collapse collapse">
                            <!-- Panel body -->
                            <div>
                              　　<router-link to="/ses">SESサービス</router-link><br>
                              　　<router-link to="/dev">ソフトウェア受託開発</router-link><br>
                              　　<a href="#">IT人材育成</a>
                            </div>
                         </div>
                      </div>
                      <div>
                         <div class="panel-heading">
                            <h4 class="panel-title">
                              <a data-toggle="collapse" data-parent="#accordion-footer" href="#collapse2-alt3">
                                <i class="fa fa-angle-right"></i><a href="recruit.html">採用情報</a>
                              </a>
                            </h4>
                         </div>
                         <div id="collapse2-alt3" class="panel-collapse collapse">
                            <div>
                              
                            </div>
                         </div>
                      </div>
                      <div>
                         <div class="panel-heading">
                            <h4 class="panel-title">
                              <a data-toggle="collapse" data-parent="#accordion-footer" href="#collapse4-alt3">
                                <i class="fa fa-angle-right"></i><a href="contact.html">お問合せ</a>
                              </a>
                            </h4>
                         </div>
                         <div id="collapse4-alt3" class="panel-collapse collapse">
                            <div>
                              
                            </div>
                         </div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="widget">
                    <h4 class="widgetheading">連絡先</h4>
                    <strong class="icon-location-pin"> <b>住所</b></strong>
                     〒230-0017 神奈川県横浜市鶴見区　<br>
                     東寺尾中台6-28 旭誠ビル<br>
                     <strong class="icon-map"> <b>交通</b></strong>
                      ＪＲ京浜東北・根岸線 大船行 鶴見駅
                    <p>
                        <i class="icon-phone"></i> <b>TEL</b> : 080-4534-2556 <br>
                        <i class="icon-envelope"></i> <b>MAIL</b> : sales@asatex.jp <br>
                        <i class="icon-globe"></i> <b>URL</b> : http://www.asatex.jp
                    </p>
                </div>
            </div>
            <!--
            <div class="col-md-3">
                <div class="widget">
                    <h5 class="widgetheading">Latest posts</h5>
                    <ul class="link-list">
                        <li><a href="#">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</a></li>
                        <li><a href="#">Pellentesque et pulvinar enim. Quisque at tempor ligula</a></li>
                        <li><a href="#">Natus error sit voluptatem accusantium doloremque</a></li>
                    </ul>
                </div>
            </div>
            
            <div class="col-md-3">
                <div class="widget">
                    <h5 class="widgetheading">Recent News</h5>
                    <ul class="link-list">
                        <li><a href="#">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</a></li>
                        <li><a href="#">Pellentesque et pulvinar enim. Quisque at tempor ligula</a></li>
                        <li><a href="#">Natus error sit voluptatem accusantium doloremque</a></li>
                    </ul>
                </div>
            </div>
            -->
            <div class="col-md-3">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3248.037353537548!2d139.6915903151063!3d35.50335458023619!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60186756f863076d%3A0x3fea1bb032d82975!2z44Kv44Ot44K344Kn44OD44OI!5e0!3m2!1sja!2sjp!4v1639976455019!5m2!1sja!2sjp" width="300" height="250" frameborder="0" style="border:0" allowfullscreen></iframe>
            </div>
        </div>
    </div>
    <div id="sub-footer">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="copyright">
                        <p>
                            Copyright &copy; 2019.Company name All rights reserved.<br><a href="http://www.asatex.jp/" target="_blank" title="株式会社アサテクス">株式会社アサテクス</a>
                        </p>
                    </div>
                </div>
                <div class="col-lg-6">
                    <ul class="social-network">
                        <li><a href="#" data-placement="top" title="Facebook"><i class="fa fa-facebook"></i></a></li>
                        <li><a href="#" data-placement="top" title="Twitter"><i class="fa fa-twitter"></i></a></li>
                        <li><a href="#" data-placement="top" title="Linkedin"><i class="fa fa-linkedin"></i></a></li>
                        <li><a href="#" data-placement="top" title="Pinterest"><i class="fa fa-pinterest"></i></a></li>
                        <li><a href="#" data-placement="top" title="Google plus"><i class="fa fa-google-plus"></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>
  </template>
  
  <script>
  export default {
    name: 'Footer',
    props: {
      msg: String
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  </style>
  